import loadable from '@loadable/component';
import Loading from '../components/Loader';

const Directory = loadable(
  () => import(/* webpackChunkName: "directory" */ '../containers/Directory'),
  {
    loading: Loading
  }
);

export default Directory;
